import { Autocomplete, Chip as MuiChip, TextField } from "@mui/material";
import { Chip } from "../interfaces";
import { makeStyles } from "@mui/styles";

interface ChipsProps {
  items: Chip[];
}

const useStyles = makeStyles(() => ({
  chipStyles: {
    "&.MuiChip-root": {
      marginRight: "20px",
      backgroundColor: "#8476EF",
      color: "#FFFFFFDE",
      lineHeight: "20px",
    },
  },
}));

export default function Chips({ items }: ChipsProps) {
  const classes = useStyles();

  return (
    <>
      {items.map((chip, i) => {
        const { title, render = true } = chip;

        if (!render) return null;

        return (
          <MuiChip
            key={i}
            size="small"
            className={classes.chipStyles}
            label={title}
          />
        );
      })}
    </>
  );
}
